import { buildQuery } from '@/lib/helper';
import client from '@/lib/http-client';

const endpoint = '/admin/monitoring-stock';

export default {
	index(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	export(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/export?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
